import { Navigate, Route, Routes } from 'react-router-dom';
import { getRuntimeConfig } from '@shared/config/runtime';
import Layout from '../components/Layout';
import RequireAuth from '../components/RequireAuth';
import ActivityPage from '../pages/ActivityPage';
import AuthCallbackPage from '../pages/AuthCallbackPage';
import ClientsPage from '../pages/ClientsPage';
import ControlledEvaluationAccessPage from '../pages/ControlledEvaluationAccessPage';
import ClientAccountsPage from '../pages/ClientAccountsPage';
import DashboardPage from '../pages/DashboardPage';
import EvidencePackagesPage from '../pages/EvidencePackagesPage';
import PackageDetailPage from '../pages/PackageDetailPage';
import JobsPage from '../pages/JobsPage';
import LoginPage from '../pages/LoginPage';
import OutreachPage from '../pages/OutreachPage';

function ProtectedLayout() {
  const { outreachTrackingEnabled } = getRuntimeConfig();

  return (
    <RequireAuth>
      <Layout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/controlled-evaluation-access" element={<ControlledEvaluationAccessPage />} />
          <Route path="/clients/:clientId/accounts" element={<ClientAccountsPage />} />
          {outreachTrackingEnabled && <Route path="/outreach" element={<OutreachPage />} />}
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/evidence-packages" element={<EvidencePackagesPage />} />
          <Route path="/evidence-packages/:clientId/:accountId/:packageId" element={<PackageDetailPage />} />
          <Route path="/activity" element={<ActivityPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </RequireAuth>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/*" element={<ProtectedLayout />} />
    </Routes>
  );
}
